import { useEffect } from "react";
import { departments } from "@/mocks/departments";

function generateAccentScale(baseL: number, baseC: number, baseH: number): Record<string, string> {
  const clamp = (v: number, min: number, max: number) => Math.max(min, Math.min(max, v));
  return {
    "--accent-50": `${clamp(baseL + 0.30, 0, 0.97)} ${(baseC * 0.20).toFixed(3)} ${baseH}`,
    "--accent-100": `${clamp(baseL + 0.25, 0, 0.95)} ${(baseC * 0.30).toFixed(3)} ${baseH}`,
    "--accent-200": `${clamp(baseL + 0.19, 0, 0.93)} ${(baseC * 0.45).toFixed(3)} ${baseH}`,
    "--accent-300": `${clamp(baseL + 0.13, 0, 0.90)} ${(baseC * 0.65).toFixed(3)} ${baseH}`,
    "--accent-400": `${clamp(baseL + 0.06, 0, 0.85)} ${(baseC * 0.85).toFixed(3)} ${baseH}`,
    "--accent-500": `${baseL} ${baseC} ${baseH}`,
    "--accent-600": `${clamp(baseL - 0.07, 0.06, 1)} ${(baseC * 0.90).toFixed(3)} ${baseH}`,
    "--accent-700": `${clamp(baseL - 0.14, 0.05, 1)} ${(baseC * 0.80).toFixed(3)} ${baseH}`,
    "--accent-800": `${clamp(baseL - 0.22, 0.04, 1)} ${(baseC * 0.60).toFixed(3)} ${baseH}`,
    "--accent-900": `${clamp(baseL - 0.28, 0.03, 1)} ${(baseC * 0.40).toFixed(3)} ${baseH}`,
    "--accent-950": `${clamp(baseL - 0.34, 0.02, 1)} ${(baseC * 0.25).toFixed(3)} ${baseH}`,
  };
}

const defaultAccent = departments.find((d) => d.id === "ti")!.accentColor;

export function useDepartmentAccent(departmentId: string | null) {
  useEffect(() => {
    const dept = departmentId ? departments.find((d) => d.id === departmentId) : null;
    const colorStr = dept?.accentColor || defaultAccent;
    const parts = colorStr.split(" ").map(Number);
    const scale = generateAccentScale(parts[0], parts[1], parts[2]);

    const root = document.documentElement;
    Object.entries(scale).forEach(([key, value]) => {
      root.style.setProperty(key, value);
    });

    return () => {
      const defaultParts = defaultAccent.split(" ").map(Number);
      const defaultScale = generateAccentScale(defaultParts[0], defaultParts[1], defaultParts[2]);
      Object.keys(defaultScale).forEach((key) => {
        root.style.setProperty(key, defaultScale[key]);
      });
    };
  }, [departmentId]);
}